import { render, staticRenderFns } from "./SpendingDonut.vue?vue&type=template&id=25444b32"
import script from "./SpendingDonut.vue?vue&type=script&lang=js"
export * from "./SpendingDonut.vue?vue&type=script&lang=js"
import style0 from "./SpendingDonut.vue?vue&type=style&index=0&id=25444b32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports